import React from 'react'
import './User_SetRoleState.css'
import '../../UserPanel.css'
import {ROLE_IMAGES_BIG, ROLE_NAMES_BIG_CARD, ROLES_COUNT} from "../../../../constants/Constants";
import User_SetRoleStat_RoleCard_Big from "./User_SetRoleState_RoleCard_Big";
import User_SetRoleStat_UserCard from "./User_SetRoleState_UserCard";
import {HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import agent from "../../../../agent";
class User_SetRoleState extends React.Component{
    onDropRole(user, item){
        console.log(user)
        let role = item.name;
        let users = this.props.team.users;
        let request = {};
        for (let i = 0; i < users.length; i++){
            users[i].role = users[i].role.filter(x => x !== role);
            if(users[i] === user){
                users[i].role.push(role);
            }

            request[ users[i].uuid] = users[i].role;
        }
        console.log(request)
        agent.Game.setRole(request, (response) =>{
            console.log(response)
            this.props.parent.readGame();
        });
    }
    render() {
        let roleCards = []
        let users =  this.props.team.users.sort((x, y)=> {
            return x.uuid === this.props.player.playerID ? -1 :
                y.uuid === this.props.player.playerID ? 1 : 0 });
        for (let i = 0; i < ROLES_COUNT; i++)
        {
            roleCards.push(<User_SetRoleStat_RoleCard_Big
                index={i}
                roleBG={ROLE_IMAGES_BIG[i + 1]}
                roleName={ROLE_NAMES_BIG_CARD[i+1]}
                isAvaliable={UtilsFunctions.usersHasRole(users, i + 1)}/>);
        }

        let userCards = []
        for (let i = 0; i < users.length; i++){
            let user = users[i];
            userCards.push(
                <User_SetRoleStat_UserCard
                    key={i}
                    user={user}
                    isCurrentPlayer={user.uuid === this.props.player.playerID}
                    onDrop={(item) => {
                            this.onDropRole(user, item);
                        }
                    }
                />)
        }
        return <div >
            <DndProvider backend={HTML5Backend}>
                <div className="user-set-logo-status-container">

                    <div className='user-header-text'>Роли</div>
                    <div className='user-set-role-state-tooltip'>
                        Обсудите и распределите командные роли. <br/>
                        По готовности сообщите преподавателю.
                    </div>
                    <div className='user-set-role-state-role-cards'>
                            {roleCards}
                    </div>
                </div>
                <div className='user-set-role-state-user-cards'>
                    {userCards}
                </div>
            </DndProvider>
        </div>
    }
}
export default User_SetRoleState;
